import { DateTime } from 'luxon';
import queryString from 'query-string';

export function queryStringUtils(searchStr: string): Record<string, any> {
  // brackets are decoded before parsing in a special case they were encoded and will not be parsed as a separator
  // this will cause a bug if someone includes | in a search query
  const query: Record<string, unknown> = queryString.parse(searchStr.replaceAll(/%7C/g, '|'), {
    parseNumbers: false,
    parseBooleans: true,
    arrayFormat: 'bracket-separator',
    arrayFormatSeparator: '|',
    decode: true,
  });

  return query;
}

export const stringifySearch = (search: Record<string, any>) => {
  if (Object.keys(search).length === 0) {
    return '';
  }

  return `?${queryString.stringify(search, { arrayFormat: 'bracket-separator', arrayFormatSeparator: '|' })}`;
};

export const encodeDate = (date?: Date | null) => {
  if (!date) {
    return undefined;
  }

  const ds = DateTime.fromJSDate(date);

  return ds.isValid ? ds.toISODate() : undefined;
};

export const decodeDate = (dateString: string) => {
  const ds = DateTime.fromISO(dateString);

  return ds.isValid ? ds.toJSDate() : undefined;
};
